module.exports = __webpack_public_path__ + "static/img/powerD.8dcbac25.png";